var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { createBrowserHistory } from "history";
import { AuthRepository } from "ftl-auth-module";
//types
import { getHeaders } from "./util";
import { errorPageService } from "../services/errorPageService";
//util
export const history = createBrowserHistory();
export default ({ baseUrl, tokenRefresh, authErrors = {
    reasonKey: "reason",
    tokenExpired: ["ACCESS_TOKEN_EXPIRED"],
    permissionInsufficient: ["CREDENTIAL_PERMISSION_INSUFFICIENT"],
    needToLogin: [
        "CREDENTIAL_BLOCKED",
        "ACCESS_TOKEN_INACTIVATED",
        "ACCESS_TOKEN_NOT_EXIST",
        "ACCESS_TOKEN_REFRESHED",
        "ACCESS_TOKEN_MODIFIED",
        "ACCESS_TOKEN_MALFORMED",
    ],
}, }) => {
    const headers = getHeaders();
    const repository = axios.create({
        headers,
        baseURL: baseUrl,
    });
    repository.interceptors.request.use((request) => {
        const token = AuthRepository.tokens.accessToken;
        if (token) {
            request.headers.common["X-Auth-Token"] = token;
        }
        return request;
    }, (error) => error);
    repository.interceptors.response.use((response) => {
        return response;
    }, (error) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const reason = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors[0]) === null || _c === void 0 ? void 0 : _c[authErrors.reasonKey || "reason"];
        if (authErrors.tokenExpired.includes(reason)) {
            let response;
            try {
                response = (yield tokenRefresh()).data.result;
                if ("accessToken" in response === false)
                    throw response;
            }
            catch (err) {
                AuthRepository.clearCookies();
                errorPageService.show({
                    error: err,
                    buttons: ["toLoginPage"],
                });
                return Promise.reject();
            }
            const config = error.config;
            config.headers["X-Auth-Token"] = response.accessToken;
            return yield repository.request(config);
        }
        else if (authErrors.permissionInsufficient.includes(reason)) {
            errorPageService.show({
                error,
                buttons: ["goBack"],
            });
            return Promise.reject();
        }
        else if (authErrors.needToLogin.includes(reason)) {
            AuthRepository.clearCookies();
            errorPageService.show({
                error,
                buttons: ["toLoginPage"],
            });
            return Promise.reject();
        }
        return Promise.reject(error);
    }));
    return repository;
};
//# sourceMappingURL=index.js.map